module.exports = ".specfic{\r\n    height: 150px !important;\r\n    width: 150px !important;\r\n  }\r\n  \r\n  "